var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 160,
    viewBox: "0 0 161 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.326172,
    width: 160,
    height: 160,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.3262 85C82.5353 85 84.3262 83.2091 84.3262 81C84.3262 78.7909 82.5353 77 80.3262 77C78.117 77 76.3262 78.7909 76.3262 81C76.3262 83.2091 78.117 85 80.3262 85Z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3262 72C76.7739 72 76.3262 72.4477 76.3262 73V74H72.3262C71.7739 74 71.3262 74.4477 71.3262 75V87C71.3262 87.5523 71.7739 88 72.3262 88H88.3262C88.8785 88 89.3262 87.5523 89.3262 87V75C89.3262 74.4477 88.8785 74 88.3262 74H84.3262V73C84.3262 72.4477 83.8785 72 83.3262 72H77.3262ZM73.3262 76V86H87.3262V76H73.3262Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnail);
export default __webpack_public_path__ + "static/media/thumbnail.067e5c34614272c73461aa9b1a4fc879.svg";
export { ForwardRef as ReactComponent };